module.exports = __webpack_public_path__ + "img/stock7.42f36288.png";